// @flow
import { Box, Button, Grid } from '@material-ui/core';
import { GatsbyImage } from 'gatsby-plugin-image';
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';
import isEqual from 'lodash.isequal';

const useStyles = makeStyles((theme) => ({
  selectedButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  noSelectedButton: {
    border: `none`,
  },
  productImageContainer: {
    paddingTop: 130,
    backgroundColor: 'white',
    minHeight: 'calc(100vh)',
  },
  slide: {
    width: '100%',
  },
}));

type Props = {
  images: any,
  title: string,
};

const ProductGallery = ({ images, title }: Props) => {
  const [currentImage, setCurrentImage] = React.useState(images[0]);
  const classes = useStyles();

  return (
    <Grid
      item
      lg={8}
      xs={12}
      md={7}
      container
      direction="row"
      justifyContent="center"
      className={classes.productImageContainer}
    >
      <Grid item xs={10}>
        <GatsbyImage
          objectFit="contain"
          loading="lazy"
          alt={
            currentImage.altText ? currentImage.altText : `Imagen de ${title}`
          }
          image={currentImage.gatsbyImageData}
          className={classes.slide}
        />
      </Grid>
      <Grid item xs={10}>
        <Box
          marginTop={3}
          marginBottom={3}
          justifyContent="center"
          display="flex"
        >
          {images.map((image, index) => (
            <Box key={image.id} paddingLeft={index > 0 ? 3 : 0}>
              <Button
                className={
                  isEqual(currentImage, image)
                    ? classes.selectedButton
                    : classes.noSelectedButton
                }
                onClick={() => setCurrentImage(image)}
              >
                <GatsbyImage
                  objectFit="contain"
                  loading={index === 0 ? 'eager' : 'lazy'}
                  alt={
                    image?.altText
                      ? image?.altText
                      : `Imagen de ${title} #${index + 1}`
                  }
                  image={image.thumbnail}
                />
              </Button>
            </Box>
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProductGallery;
